import { createFileRoute } from '@tanstack/react-router';
import { ActivityPage } from '@/features/organization/activity/activity-page';

export const Route = createFileRoute('/_app/o/$organizationId/settings/activity')({
    staticData: { crumbs: [{ label: 'settings.nav.activity' }] },
    component: function ActivityRoute() {
        const { organizationId } = Route.useParams();
        return <ActivityPage organizationId={organizationId} />;
    },
});
